import { Usuario } from '../@types';
import Service from './Service';

class AuthorizationService extends Service {

  static getToken(loginData: any): Promise<Usuario.Token> {
    return this.Http.post<Usuario.Token>(`/auth/login`, loginData).then(this.getData);
  }

  static getUser(token: string): Promise<Usuario.Usuario> {
    return this.Http.get<Usuario.Usuario>(`/auth/${token}`).then(this.getData);
  }

  static register(data: {
    email: string;
    userName: string;
    fullName: string;
    password: string;
    profile: string;
  }): Promise<{ message: string }> {
    return this.Http.post<{ message: string }>(`/auth/register`, data).then(this.getData);
  }

  static verifyEmail(token: string): Promise<{ message: string }> {
    return this.Http.get<{ message: string }>(`/auth/verify-email`, { params: { token } }).then(this.getData);
  }

  static resendVerificationEmail(email: string): Promise<{ message: string }> {
    return this.Http.post<{ message: string }>(`/auth/resend-verification-email`, { email }).then(this.getData);
  }

  static forgotPassword(email: string): Promise<{ message: string }> {
    return this.Http.post<{ message: string }>(`/auth/forgot-password`, { email }).then(this.getData);
  }

  static resetPasswordByToken(token: string, password: string): Promise<{ message: string }> {
    return this.Http.post<{ message: string }>(`/auth/reset-password-by-token`, { token, password }).then(this.getData);
  }

  static checkAvailability(params: { email?: string; userName?: string }): Promise<{ emailAvailable?: boolean; userNameAvailable?: boolean }> {
    return this.Http.get<{ emailAvailable?: boolean; userNameAvailable?: boolean }>(`/auth/check-availability`, { params }).then(this.getData);
  }

}

export default AuthorizationService;
